import { FontType } from '@primitives/Typography/types';
import { statusLabelSizeType } from './types';

export const labelSizeToFontSize: Record<statusLabelSizeType, FontType> = {
    small: 'p5',
    medium: 'p3',
    large: 'p2',
};
